<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-info-circle fa-lg icon-button"
                title="Detalhar"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal
            v-model="mostrarModal"
            :no-close-on-backdrop="true"
            size="lg"
        >
            <div slot="modal-title">
                Detalhes do Relatório LAI
            </div>
            <div v-if="relatorio">
            <b-row>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>Atualizado em:</strong></span><br />
                        <span>{{
                            relatorio.atualizadoEm
                                ? $moment(relatorio.atualizadoEm).format(
                                      'DD/MM/YYYY HH:mm'
                                  )
                                : '-'
                        }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>Criado por:</strong></span><br />
                        <span>{{ relatorio.criadoPor || '-' }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>Entidade/Órgão:</strong></span><br />
                        <span>{{ relatorio.nomeEntidadeOuOrgao || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>Objeto do Contrato:</strong></span><br />
                        <span>{{ relatorio.objeto || '-' }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>Contratada:</strong></span><br />
                        <span>{{ relatorio.contratada || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>CNPJ da Contratada:</strong></span><br />
                        <span>{{ relatorio.cnpjContratada ? formatarCNPJ(relatorio.cnpjContratada) : '-' }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>Nº do Contrato:</strong></span><br />
                        <span>{{ relatorio.numeroContrato || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="6">
                    <div class="mb-3">
                        <span><strong>Ano do Contrato:</strong></span><br />
                        <span>{{ relatorio.anoContrato || '-' }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Nº Processo Licitatório:</strong></span><br />
                        <span>{{ relatorio.numeroProcessoLicitatorio || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Início da Vigência:</strong></span><br />
                        <span>{{
                            relatorio.vigenciaInicio
                                ? $moment(relatorio.vigenciaInicio).format(
                                      'DD/MM/YYYY'
                                  )
                                : '-'
                        }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Fim da Vigência:</strong></span><br />
                        <span>{{
                            relatorio.vigenciaFim
                                ? $moment(relatorio.vigenciaFim).format(
                                      'DD/MM/YYYY'
                                  )
                                : '-'
                        }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Aditivo de Prazo:</strong></span><br />
                        <span>{{ relatorio.aditivoPrazo || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Nº do Apostilamento:</strong></span><br />
                        <span>{{ relatorio.numeroApostilamento || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Aditivo de Valor:</strong></span><br />
                        <span>{{ relatorio.aditivoValor || '-' }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Valor Mensal:</strong></span><br />
                        <span class="text-nowrap">{{
                            relatorio.valorMensal | currency
                        }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Valor Total do Contrato:</strong></span><br />
                        <span class="text-nowrap">{{
                            relatorio.valorTotalContrato | currency
                        }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Valor Executado:</strong></span><br />
                        <span class="text-nowrap">{{
                            relatorio.valorExecutado | currency
                        }}</span>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Modalidade de Licitação:</strong></span><br />
                        <span>{{ relatorio.modalidadeLicitacao || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Nome do Fiscal do Contrato:</strong></span><br />
                        <span>{{ relatorio.nomeFiscalContrato || '-' }}</span>
                    </div>
                </b-col>
                <b-col sm="12" md="4">
                    <div class="mb-3">
                        <span><strong>Situação:</strong></span><br />
                        <span>{{ relatorio.situacao || '-' }}</span>
                    </div>
                </b-col>
            </b-row>
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    components: {},

    props: {
        relatorio: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        formatarCNPJ(valor) {
            if (!valor) return '';

            const raw = valor.replace(/[^a-zA-Z0-9]/g, '').slice(0, 14);

            let formatted = raw;

            if (raw.length > 2) {
                formatted = raw.slice(0, 2) + '.' + raw.slice(2);
            }
            if (raw.length > 5) {
                formatted = formatted.slice(0, 6) + '.' + formatted.slice(6);
            }
            if (raw.length > 8) {
                formatted = formatted.slice(0, 10) + '/' + formatted.slice(10);
            }
            if (raw.length > 12) {
                formatted = formatted.slice(0, 15) + '-' + formatted.slice(15);
            }
            return formatted;
        },
    },
}
</script>

